import Sentry from '@/services/sentry'
import CountingApi from '@/api/counting'

const resetCounting = async (_, payload) => {
  try {
    return await CountingApi.deleteCountingUnique(payload)
  } catch (error) {
    Sentry.captureException(new Error('Reset counting error'), {
      extra: {
        error,
        payload,
      },
    })
    return null
  }
}

export default {
  resetCounting,
}
